import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_colorpicker');

register('wm-colorpicker', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          return `<${tagName} wmColorpicker #${counter}="wmColorpicker" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
